import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

import { TextareaControl } from '../model/textarea';

type TextareaProps = {
  control: TextareaControl;
  onInput: (value: string) => void;
};

const Textarea: LitheFC<TextareaProps> = ({
  control,
  onInput,
}): LitheElement<'label'> => [
  'label',
  {
    id: control.id,
    'data-testid': control.testId,
    class: [
      'text-base flex flex-col gap-1 relative',
      ...([] as string[]).concat(control.classes ?? []),
    ],
  },
  ['div', { class: 'text-primary' }, control.label],
  () => [
    'small',
    {
      id: `${control.id}-error-message`,
      class: 'absolute top-1 right-0 text-error empty:hidden',
    },
    !control.valid && control.touched ? control.errorMessage : '',
  ],
  [
    'textarea',
    {
      class: 'py-1 px-2 text-base',
      type: 'text',
      name: control.id,
      ...control.config,
      ...(control?.validations?.required ? { required: '' } : {}),
      value: control.value,
      oninput: (e: InputEvent) => onInput((e.target as HTMLInputElement).value),
    },
  ],
];

export default Textarea;
